<template>
<div class="app">
  <router-view></router-view>
  <div class="clearfix"></div>
  <notifications group="a" position="top center" />
  <Chat />
</div>
</template>

<script>
import Chat from "./components/Chat";
export default {
  name: "app",
  components: { Chat },
};
</script>
<style lang="sass">
// @import "./assets/css/template.sass"
</style>
